import { Theme, unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core";
import { enUS, faIR } from "@material-ui/core/locale";
import i18next from "i18next";
import { LocalesType } from "../constants/globals";
import { direction } from "../libs/i18n";
import { MessengerThemeType } from "../store/messenger/types";
import dark from "./dark";
import light from "./light";

const themes = {
  DARK: dark,
  LIGHT: light,
};

const themeGenerator = (value: MessengerThemeType): Theme => {
  document.querySelector("html")?.setAttribute("data-theme", value);
  document.querySelector("body")?.setAttribute("dir", direction);

  return createMuiTheme(
    {
      direction: direction,
      typography: {
        fontFamily: "var(--primary-font)",
        // fontSize: 10,
      },
      ...themes[value],
    },
    i18next.language === LocalesType["FA"] ? faIR : enUS
  );
};

export default themeGenerator;
